module.exports = __webpack_public_path__ + "static/media/tag-along-badge.93085e0a.svg";